<script>
import 'videojs-contrib-hls'
import axios from 'axios'
import { BaseURL } from '../shared/classes'
import Vue from 'vue'
import StarRating from 'vue-star-rating'
// import myVideo from 'vue-video'
import { vplayer } from 'vue-hls-player'
import router from '../router/index'
import $ from 'jquery'
import momentsone from 'moment-timezone'
export const EventBus = new Vue()
export default {
  name: 'profile-modal',
  data () {
    return {
      userid: '',
      sid: '',
      base_urls: BaseURL,
      profiledetails: [],
      profilesills: [],
      groupeddate: [],
      userInfo: [],
      scheduledetail: [],
      resultdata: [],
      feedbackdetails: [],
      feedbackdetailslength: 0,
      feedback_skills: [],
      feedback_skills_len: 0,
      postdatas: [],
      startdate: '',
      schedulevideorights: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      active_name: '',
      enddate: '',
      selectpost: '',
      showratingform: false,
      tabOne: false,
      tabTwo: false,
      tabThree: false,
      tabFour: false,
      tabFive: false,
      rating_comments: '',
      rating_count: '',
      showrating_error: false,
      validationerror: false,
      windowcheckbox: false,
      releventwork: false,
      releventeducation: false,
      course_certification: false,
      showRole: false,
      rating: 3.5,
      checkvideo: '',
      sections:
      [
        { value: 75, color: '#f39c12' }
      ],
      vOption: [],
      timezone: momentsone.tz.guess()
    }
  },
  components: {
    StarRating,
    vplayer
  },
  props: {
    shwovalueResultResult: {
      required: true
    }
  },
  created () {
    this.shwovalueResult = true
    this.userid = JSON.parse(localStorage.getItem('viewid'))
    this.selectpost = JSON.parse(localStorage.getItem('postId'))
    this.sid = JSON.parse(localStorage.getItem('sid'))
    this.userInfo = JSON.parse(localStorage.getItem('user__details'))
    var email = this.userInfo.user_email
    var sp = email.split('@')
    if (sp[1] === 'acsicorp.com') {
      // this.form.dept_name = this.dept_name[0]
      this.showRole = true
    }
    this.startdate = ''
    this.enddate = ''
    this.getresultdata()
    this.getdata()
    this.getscheduledata()
  },
  methods: {
    generateReport () {
      // this.$refs.html2Pdf.generatePdf()
      router.push({ name: 'ResultPdf' })
    },
    SendMessageToParent () {
      this.$root.$emit('message_from_abc', this.selectpost)
      this.$emit('input', !this.shwovalueResult)
    },
    scrollToElement () {
      const el = this.$el.getElementsByClassName('scroll-to-me')[0]
      if (el) {
        el.scrollIntoView()
      }
    },
    close () {
      if (this.feedbackdetailslength > 0) {
        if (this.profiledetails.isclient === 'no' && this.feedbackdetailslength > 0 && this.feedbackdetails.interviewer_rating === null) {
          this.$emit('input', !this.shwovalueResult)
          this.ratingpopup()
        } else {
          this.$emit('input', !this.shwovalueResult)
        }
      } else {
        this.$emit('input', !this.shwovalueResult)
      }
    },
    ratingpopup () {
      console.log('cancel start')
      this.$root.$emit('message_get_rating', this.scheduledetail._id)
    },
    subscribepopup () {
      console.log('subscribe start')
      this.$root.$emit('message_get_subscribe', this.scheduledetail._id)
    },
    subscribepopup1 () {
      console.log('subscribe start')
      this.$root.$emit('message_get_subscribe1', this.scheduledetail._id)
    },
    groupBy (array, key) {
      const result = {}
      this.groupeddate = []
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
          // this.groupeddate.push(item);
        }
        result[item[key]].push(item)
      })
      this.groupeddate = result
      console.log(this.groupeddate)
    },
    getscheduledata () {
      const mainurl = '/dashboard/get_schedule_detail/web/' + this.sid
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.scheduledetail = response.data.scheduleList[0]
        if (this.scheduledetail) {
          this.schedulevideo = this.scheduledetail.interviewer_video
          this.schedulevideorights = this.scheduledetail.client_video_rights
          console.log(this.scheduledetail.video_rights)
          this.checkvideo = this.scheduledetail.video_rights
        }
        this.vOption = {
          type: 'application/x-mpegURL',
          src: this.schedulevideo,
          preload: true,
          autoplay: false,
          isLoop: false,
          // poster: 'https://oimdztrab.qnssl.com/Frp4SyVe5PosdkUKRaE-krjK7B5z',
          controls: 'progress,current,durration,volume',
          crossOrigin: false
        }
        this.tabFive = true
      }).catch(e => {
        console.log(e)
      })
    },
    getresultdata () {
      console.log(this.showRole)
      let mainurl = ''
      if (this.showRole) {
        mainurl = '/dashboard/get_acs_feedback/' + this.sid
      } else {
        mainurl = '/dashboard/get_schedule_feedback_details/web/' + this.sid
      }
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        if (this.showRole) {
          this.feedbackdetailslength = response.data.feedback_detail.length
          this.feedbackdetails = response.data.feedback_detail[0]
        } else {
          this.feedbackdetailslength = response.data.feedbackdetails.length
          this.feedbackdetails = response.data.feedbackdetails[0]
        }
        if (this.feedbackdetailslength > 0) {
          // this.feedback_skills = response.data.feedback_skills
          // this.feedback_skills_len = response.data.feedback_skills.length
          // this.active_name = this.feedback_skills[0]._id
          // if (this.feedbackdetails.window_violation === 'yes' && this.feedbackdetails) {
          //   this.windowcheckbox = true
          // } else {
          //   this.windowcheckbox = false
          // }
          // if (this.feedbackdetails.edu_background === 'yes' && this.feedbackdetails) {
          //   this.releventeducation = true
          // } else {
          //   this.releventeducation = false
          // }
          // if (this.feedbackdetails.work_experience === 'yes' && this.feedbackdetails) {
          //   this.releventwork = true
          // } else {
          //   this.releventwork = false
          // }
          // if (this.feedbackdetails.course_certification === 'yes' && this.feedbackdetails) {
          //   this.course_certification = true
          // } else {
          //   this.course_certification = false
          // }
        }
      }).catch(e => {
        console.log(e)
      })
    },
    openVideo () {
      router.push({ name: 'Showvideo', params: { id: this.schedulevideo } })
    },
    getdata () {
      const mainurl = '/dashboard/get_profile_detail/' + this.userid + '/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.profiledetails = response.data.profileDetail[0]
        this.profilesills = response.data.profileSkillList
        this.groupBy(response.data.availabilityDetails, 'startdate')
      }).catch(e => {
        console.log(e)
      })
    },
    changeskill (id) {
      this.active_name = id
    },
    setCurrentRating (e) {
      console.log(e)
      this.rating_count = e
      this.showrating_error = false
    },
    changecomments () {
      this.showrating_error = false
    },
    play (e) {
      console.log(e)
      console.log(this.checkvideo)
      if (this.checkvideo === 'no' && this.profiledetails.isclient === 'yes') {
        $('video').trigger('pause')
        this.$emit('input', !this.shwovalueResult)
        this.subscribepopup1()
      } else if (this.checkvideo === 'no' && this.profiledetails.isclient === 'no') {
        $('video').trigger('pause')
        this.$emit('input', !this.shwovalueResult)
        this.subscribepopup()
      }
    },
    pause (e) {
      console.log(e)
      return false
    },
    ratingsubmit () {
      console.log(this.rating_count)
      if (this.rating_count === undefined || this.rating_count === '' || this.rating_count === null) {
        this.showrating_error = true
        return false
      } else {
        this.showrating_error = false
      }
      this.postdatas = {
        schedule_id: this.sid,
        interviewer_rating: this.rating_count,
        interviewer_rating_comments: this.rating_comments
      }
      const mainurl = '/dashboard/add_rating_to_interviewer'
      this.feedbackdetails.interviewer_rating = this.rating_count
      axios.post(`${this.base_urls}${mainurl}`, { formData: this.postdatas }, this.config).then(response => {
        this.rating_comments = ''
        this.getresultdata()
        this.$emit('input', !this.shwovalueResult)
        this.$awn.success('Successfully updated')
      }).catch(e => {
        console.log(e)
      })
    },
    viewasFeedback () {
      let routerPage = ''
      routerPage = this.$router.resolve('/viewfeedback_org/' + this.sid)
      // if (this.showRole) {
      //   routerPage = this.$router.resolve('/viewfeedback/' + this.sid)
      // } else {
      //   routerPage = this.$router.resolve('/viewfeedbackcommon/' + this.sid)
      // }
      window.open(routerPage.href, '_blank')
      // window.open('/viewfeedbackcommon/' + this.sid)
    },
    getTime (date) {
      const Start = momentsone.utc(date).tz(this.timezone).format('hh:mm a')
      return Start
    },
    getDate (date) {
      const Start = momentsone.utc(date).tz(this.timezone).format('DD MMM yyyy')
      return Start
    }
  }
}
</script>

<template>
<row>
<!-- <div class="custom-modal-backdrop" v-show="shwovalueResult">  -->
  <div class="modal fade1 in" id="modal-default" style="display: block;" v-show="shwovalueResult">
  <div class="modal-dialog" style="padding-top: 5%;">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" @click="close()">×</span></button>
          <h4 class="modal-title">Result</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-7 p-1">
            <div class="col-md-2">
              <!-- <img src="../../assets/img/default.png" class="img-circle" alt="User Image"> -->
              <img v-if="profiledetails.profile_picture !='' && profiledetails.profile_picture !=null" :src="`${profiledetails.profile_picture}`" class="img-circle">
              <img v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null" src="../assets/img/default.png" class="img-circle">
            </div>
            <div class="col-md-10">
              <div class="col-md-6 p-1">
                <div>
                  <span class="direct-chat-timestamp pull-left f12">Candidate Name</span><br>
                  <span class="direct-chat-name pull-left f12 emailover">{{scheduledetail.candidate_name}}</span>
                </div><br>
                <div class="mt-2">
                  <span class="direct-chat-timestamp pull-left f12">Designation</span><br>
                  <span class="direct-chat-name pull-left f12">{{profiledetails.designation}}</span>
                </div><br>
                <div class="mt-2">
                  <span class="direct-chat-timestamp pull-left f12">Email</span><br>
                  <span class="direct-chat-name pull-left f12 emailover" :title="scheduledetail.candidate_email" v-if="scheduledetail.candidate_email">{{scheduledetail.candidate_email}}</span>
                  <span class="direct-chat-name pull-left f12" v-if="scheduledetail.candidate_email =='' || scheduledetail.candidate_email ==null">NA</span>
                </div>
              </div>
              <div class="col-md-6 p-1" v-if="feedbackdetailslength > 0">
                <div>
                  <span class="direct-chat-timestamp pull-left f12">Feedback Status</span><br>
                  <span class="direct-chat-name pull-left f12" v-if="scheduledetail.feedback_status =='Completed'" style="color:#5bad2b;">Completed</span>
                  <span class="direct-chat-name pull-left f12" v-if="scheduledetail.feedback_status =='Incomplete' || scheduledetail.feedback_status =='Incompleted'" style="color:#5bad2b;">Incompleted</span>
                </div><br>
                <div class="mt-2">
                  <span class="direct-chat-timestamp pull-left f12">Interview Status</span><br>
                  <span class="direct-chat-name pull-left f12" v-if="feedbackdetails.interview_status =='Completed'" style="color:#5bad2b;">Completed</span>
                  <span class="direct-chat-name pull-left f12" v-if="feedbackdetails.interview_status =='Incomplete' || feedbackdetails.interview_status =='Incompleted'" style="color:#5bad2b;">Incompleted</span>
                </div><br>
                <div class="mt-2">
                  <span class="direct-chat-timestamp pull-left f12">Interview Duration</span><br>
                  <span class="direct-chat-name pull-left f12" v-if="scheduledetail.interview_duration">{{scheduledetail.interview_duration}}</span>
                  <span class="direct-chat-name pull-left f12" v-if="!scheduledetail.interview_duration">NA</span>
                </div>
                <!-- <div class="mt-2">
                  <img v-if="feedbackdetails.eligible_for_this_position !='yes' && feedbackdetails.eligible_for_this_position !=''" src="../../assets/img/stamp.png" alt="User Image">
                  <img v-if="feedbackdetails.eligible_for_this_position =='yes' && feedbackdetails.eligible_for_this_position !=''" src="../../assets/img/stamp-eligble.png" alt="User Image">
                </div> -->
              </div>
              <div class="col-md-6 p-1" v-if="feedbackdetailslength < 1">
                <div>
                  <span class="direct-chat-timestamp pull-left f12">Feedback status</span><br>
                  <span class="direct-chat-name pull-left f12" style="color:red;">Pending</span>
                </div><br>
                <div class="mt-2">
                  <span class="direct-chat-timestamp pull-left f12">Interview status</span><br>
                  <span class="direct-chat-name pull-left f12" style="color:#5bad2b;">Completed</span>
                </div><br>
                <div class="mt-2">
                  <span class="direct-chat-timestamp pull-left f12">Interview duration</span><br>
                  <span class="direct-chat-name pull-left f12" v-if="scheduledetail.interview_duration">{{scheduledetail.interview_duration}}</span>
                  <span class="direct-chat-name pull-left f12" v-if="!scheduledetail.interview_duration">NA</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <table>
              <thead>
                <tr>
                  <th>Interviewer Details</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-muted">Interviewer Name</td>
                  <td class="text-bold">{{profiledetails.first_name}} {{profiledetails.last_name}}</td>
                </tr>
                 <tr>
                  <td class="text-muted">Interview Date</td>
                  <!-- <td class="text-bold">{{scheduledetail.schedule_date | formatDate}}</td> -->
                  <td class="text-bold">{{getDate(scheduledetail.startdatetime_utc)}}</td>
                </tr>
                 <tr>
                  <td class="text-muted">Interview Time</td>
                  <!-- <td class="text-bold">{{scheduledetail.schedule_start_time}} - {{scheduledetail.schedule_end_time}}</td> -->
                  <td class="text-bold">{{getTime(scheduledetail.startdatetime_utc)}} - {{getTime(scheduledetail.enddatetime_utc)}}</td>
                </tr>
                 <tr>
                  <td class="text-muted">Mode of Interview</td>
                  <td class="text-bold">{{scheduledetail.job_interview_type}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="feedbackdetailslength > 0">
            <hr>
            <div class="row" v-if="feedbackdetails.interview_status =='Incomplete' || feedbackdetails.interview_status =='Incompleted'">
              <div class="col-md-12">
                <h5 style="font-weight: 600;">Reason</h5>
                <hr>
                <p>{{feedbackdetails.incomplete_reason_name}}</p>
                <h5 style="font-weight: 600;">Comments</h5>
                <hr>
                <p>{{feedbackdetails.incomplete_reason_cmt}}</p>
              </div>
            </div>
            <!-- <div style="margin-bottom: 10px;
      margin-top: 5px;" class="col-md-10" v-if="feedbackdetails.interview_status =='Incomplete' || feedbackdetails.interview_status =='Incompleted'">
              <div class="col-md-5" style="background-color: #F5F5F5;">
                <div class="direct-chat-msg">
                  <div class="clearfix">
                    <span class="direct-chat-timestamp pull-left">Reason</span>
                  </div>
                  <span class="direct-chat-name pull-left">{{feedbackdetails.incomplete_reason_name}} </span>
                </div>
              </div>
              <div class="col-md-5" style="background-color: #F5F5F5;">
                <div class="direct-chat-msg">
                  <div class="clearfix">
                    <span class="direct-chat-timestamp pull-left">Comments</span>
                  </div>
                  <span class="direct-chat-name pull-left">{{feedbackdetails.incomplete_reason_cmt}} </span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div v-if="feedbackdetailslength > 0">
          <div class="nav-tabs-custom" v-if="feedbackdetails.interview_status != 'Incomplete' || feedbackdetails.interview_status != 'Incompleted'">
            <ul class="nav nav-tabs" style="height: 33px !important;" v-if="scheduledetail.feedback_status !=='Pending'">
              <!-- <li v-bind:class="{'active': tabOne}" @click="tabOne = true, tabTwo = false, tabThree = false, tabFour = false, tabFive = false"><a href="#tab_1" class="result-tb" data-toggle="tab">Skill Details</a></li>
              <li v-bind:class="{'active': tabTwo}" @click="tabOne = false, tabTwo = true, tabThree = false, tabFour = false, tabFive = false"><a href="#tab_2" class="result-tb" data-toggle="tab">Evaluation Details</a></li>
              <li v-bind:class="{'active': tabThree}" @click="tabOne = false, tabTwo = false, tabThree = true, tabFour = false, tabFive = false"><a href="#tab_3" class="result-tb" data-toggle="tab">Comments</a></li> -->
              <li v-bind:class="{'active': tabFive}" @click="tabOne = false, tabTwo = false, tabThree = false, tabFour = false, tabFive = true"><a href="#tab_4" class="result-tb" data-toggle="tab" v-if="scheduledetail.job_interview_type != 'audio'">Interview Video</a></li>
              <li v-if="profiledetails.isclient =='no'" v-bind:class="{'active': tabFour}" @click="tabOne = false, tabTwo = false, tabThree = false, tabFour = true, tabFive = false"><a href="#tab_4" class="result-tb" data-toggle="tab">Rate this Interview</a></li>
            </ul>
          </div>
        </div>
        <!-- <div class="row" v-if="scheduledetail.feedback_status =='Pending'">
          <div class="col-md-3">
          </div>
          <div class="col-md-4">
            <img src="../../assets/img/result_pending.svg" style="max-width: 388px;" alt="User Image">
          </div>
          <div class="col-md-4">
          </div>
        </div> -->
        <!-- <div class="row" v-if="tabOne && scheduledetail.feedback_status !='Pending'"> -->
          <!-- <div class="col-md-4" v-if="feedbackdetails.interview_status != 'Incomplete' && feedbackdetails.interview_status != 'Incompleted'">
            <div class="box box-primary"> -->
              <!-- /.box-header -->
              <!-- <div v-for="x in feedback_skills" :key="x" class="box-body" @click="changeskill(x._id)" v-bind:class="{'active': active_name == x._id}">
                <div>
                  <span class="pull-left">{{x.skill_name}}</span>
                  <i class="fa fa-chevron-right margin-r-5 pull-right" style="margin-top: 3px;" v-if="active_name == x._id"></i>
                </div>
              </div> -->
              <!-- /.box-body -->
            <!-- </div> -->
          <!-- </div> -->
          <!-- <div class="col-md-7" v-if="feedbackdetails.interview_status != 'Incomplete' && feedbackdetails.interview_status != 'Incompleted'">
            <table v-for="x in feedback_skills" :key="x" v-show="active_name == x._id">
              <tbody>
                <tr>
                  <td class="text-muted" width="40%">Skillset</td>
                  <td class="text-bold">{{x.skill_name}}</td>
                </tr>
                 <tr>
                  <td class="text-muted">Skill rating</td>
                  <td class="text-bold">
                    <div style="width: 50%;">
                      <star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="x.skill_rating" read-only="true"></star-rating>
                    </div>
                  </td>
                </tr>
                 <tr>
                  <td class="text-muted">Experience</td>
                  <td class="text-bold">{{x.experience}}</td>
                </tr>
                 <tr>
                  <td class="text-muted">Scenario / program concept</td>
                  <td class="text-bold">{{x.program_concept}}</td>
                </tr>
                <tr>
                  <td class="text-muted">Logics</td>
                  <td class="text-bold">{{x.logics}}</td>
                </tr>
                <tr>
                  <td class="text-muted">Development Tools</td>
                  <td class="text-bold">{{x.development_tools}}</td>
                </tr>
              </tbody>
            </table>
          </div> -->
        <!-- </div> -->
        <!-- <div class="row" v-if="tabTwo && scheduledetail.feedback_status !='Pending'"> -->
          <!-- <div class="col-md-5" style="border-right: 1px solid #ccc;">
            <div class="box-primary"> -->
              <!-- /.box-header -->
              <!-- <div> -->
                <!-- See dist/js/pages/dashboard.js to activate the todoList plugin -->
                <!-- <ul class="todo-list ui-sortable"> -->
                  <!-- <li>
                    <span><i class="fa fa-circle-o ic"></i> Communication skills</span>
                    <small class="pull-right" style="width: 25%;"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.communication_skill" read-only="true"></star-rating></small>
                  </li> -->
                  <!-- <li>
                    <span><i class="fa fa-circle-o ic"></i> Attention to details</span>
                    <small class="pull-right" style="width: 25%;"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.attention" read-only="true"></star-rating></small>
                  </li>
                  <li>
                    <span><i class="fa fa-circle-o ic"></i> Integrity</span>
                    <small class="pull-right" style="width: 25%;"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.intrigity" read-only="true"></star-rating></small>
                  </li>
                  <li>
                    <span><i class="fa fa-circle-o ic"></i> Cooperation</span>
                    <small class="pull-right" style="width: 25%;"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.cooperation" read-only="true"></star-rating></small>
                  </li>
                  <li>
                    <span><i class="fa fa-circle-o ic"></i> Stress Tolerance</span>
                    <small class="pull-right" style="width: 25%;"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.stress_tolerance" read-only="true"></star-rating></small>
                  </li>
                  <li>
                    <span><i class="fa fa-circle-o ic"></i> Learning Ability</span>
                    <small class="pull-right" style="width: 25%;"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.learning_ability" read-only="true"></star-rating></small>
                  </li> -->
                  <!-- <li>
                    <span><i class="fa fa-circle-o ic"></i> Interpersonal skills</span>
                    <small class="pull-right" style="width: 25%;"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.inter_personal_skill" read-only="true"></star-rating></small>
                  </li> -->
                <!-- </ul>
              </div>
            </div> -->
          <!-- </div> -->
          <!-- <div class="col-md-7">
            <div class="checkbox" style="position: fixed !important;" v-if="feedbackdetails.window_violation =='yes'">
              <input type="checkbox" style="margin-left:-58px" onclick="return false;" checked>
              <label style="text-align-last: left;"><span style="margin-left: 10px">Window violation</span></label>
            </div>
            <br v-if="feedbackdetails.window_violation =='yes'">
            <br v-if="feedbackdetails.window_violation =='yes'">
            <p style="margin: 0 0 0px;" v-if="feedbackdetails.window_violation =='yes' && feedbackdetails.window_violation_cmt">Comments</p>
            <p class="text-muted" v-if="feedbackdetails.window_violation =='yes' && feedbackdetails.window_violation_cmt">{{feedbackdetails.window_violation_cmt}}</p>
            <div class="checkbox" style="position: fixed !important;" v-if="feedbackdetails.work_experience =='yes'">
              <input type="checkbox" style="margin-left:-85px" onclick="return false;" checked>
              <label style="text-align-last: left;"><span style="margin-left: 10px">Relevant Work experience</span></label>
            </div>
            <br v-if="feedbackdetails.work_experience =='yes'">
            <br v-if="feedbackdetails.work_experience =='yes'">
            <p style="margin: 0 0 0px;" v-if="feedbackdetails.work_experience =='yes' && feedbackdetails.work_experience_cmt">Comments</p>
            <p class="text-muted" v-if="feedbackdetails.work_experience =='yes' && feedbackdetails.work_experience_cmt">{{feedbackdetails.work_experience_cmt}}</p>
            <div class="checkbox" style="position: fixed !important;" v-if="feedbackdetails.edu_background =='yes'">
              <input type="checkbox" style="margin-left:-107px" onclick="return false;" checked value="1" readonly>
              <label style="text-align-last: left;"><span style="margin-left: 10px">Relevant Educational background</span></label>
            </div>
            <br v-if="feedbackdetails.edu_background =='yes'">
            <br v-if="feedbackdetails.edu_background =='yes'">
            <p style="margin: 0 0 0px;" v-if="feedbackdetails.edu_background =='yes' && feedbackdetails.edu_background_cmt">Comments</p>
            <p class="text-muted" v-if="feedbackdetails.edu_background =='yes' && feedbackdetails.edu_background_cmt">{{feedbackdetails.edu_background_cmt}}</p>
            <div class="checkbox" style="position: fixed !important;" v-if="feedbackdetails.course_certification =='yes'">
              <input type="checkbox" style="margin-left:-64px !important;" onclick="return false;" checked>
              <label style="text-align-last: left;"><span style="margin-left: 10px">Course Certification</span></label>
            </div>
            <br v-if="feedbackdetails.course_certification =='yes'">
            <br v-if="feedbackdetails.course_certification =='yes'">
            <p style="margin: 0 0 0px;" v-if="feedbackdetails.course_certification =='yes' && feedbackdetails.course_certification_cmt">Comments</p>
            <p class="text-muted" v-if="feedbackdetails.course_certification =='yes' && feedbackdetails.course_certification_cmt">{{feedbackdetails.course_certification_cmt}}</p>
            <div>
              <h5>Screenit score</h5>
              <span v-for="item in 10" :key="item" v-bind:class="{'sit-score-active': item == feedbackdetails.sit_score || item < feedbackdetails.sit_score}"  class="sit-score">{{item}}</span>
            </div>
          </div> -->
        <!-- </div> -->
        <!-- rate this Interview -->
        <div class="row" v-if="tabThree && scheduledetail.feedback_status !='Pending'">
          <div class="col-md-12">
            <p class="text-muted">Comments</p>
            <p>{{feedbackdetails.eligible_comments}}</p>
          </div>
        </div>
        <div class="row" v-if="tabFour && scheduledetail.feedback_status !='Pending'">
          <div class="col-md-12">
            <p class="text-muted" style="text-align: center;">Rate this Interview</p>
            <hr>
            <div class="given_rating" v-if="feedbackdetails.interviewer_rating ==null">
                <star-rating :show-rating="false" @current-rating="setCurrentRating($event, anotherParam)" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20"></star-rating>

            </div>
            <div class="given_rating" v-if="feedbackdetails.interviewer_rating != null">
                <!-- <star-rating :rating="feedbackdetails.interviewer_rating" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20"></star-rating> -->
                <star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="Number(feedbackdetails.interviewer_rating)" read-only="true"></star-rating>

            </div>
            <div class="ratingform">
            <div v-if="feedbackdetails.interviewer_rating ==null">
              <b-form-textarea v-model="rating_comments" class="textarea" rows="2" placeholder="Enter comments *"></b-form-textarea>
              <div class="form-submit" style="text-align: center;">
                <p style="color:red" v-if="showrating_error">Please choose a star *</p>
                <input type="submit" @click="ratingsubmit()" style="cursor:pointer" value="Submit" class="submit" name="submit" id="submit" />
              </div>
            </div>
            <div v-if="feedbackdetails.interviewer_rating != null">
              <label>comments</label>
              <p>{{feedbackdetails.interviewer_rating_comments}}</p>
            </div>
          </div>
          </div>
        </div>
        <!-- video -->
        <div class="row" v-if="tabFive && scheduledetail.feedback_status !='Pending'">
          <div class="col-md-12">
            <!-- <p class="text-muted" style="text-align: center;">Rate this Interview</p> -->
            <hr>
              <vplayer :playerOptions = "vOption" @onplay="play" @onpause="pause" />
          </div>
          </div>
          </div>
          <div class="modal-footer" v-if="feedbackdetailslength > 0 && scheduledetail.feedback_status !=='Pending'">
            <!-- <router-link type="button" :to="{ name: 'ResultPdf'}" target="_blank" class="btn btn-success">
              Download as PDF
            </router-link> -->
            <!-- <router-link type="button" to="/viewfeedbackcommon/280" target="_blank" class="btn btn-success">
              View as FeedBack
            </router-link> -->
            <button type="button" @click="viewasFeedback()" class="btn btn-success">View FeedBack</button>
            <!-- <button type="button" @click="generateReport()" class="btn btn-success">Download as PDF</button> -->
          </div>
        </div>
      </div>
   </div>
    </row>
    <!-- /.modal-content -->
</template>
<style scoped>
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      width: 801px;
  }
}
.modal { overflow: auto !important; }
.modal-header {
  padding: 8px !important;
}
img {
    max-width: 64px;
}
.btns {
  background-color: white;
  color: #5bad2b;
  margin-right: 0px;
  height: 32px;
}
.modal-header {
  background-color: #F5F5F5;
  border-bottom: 1px solid #cccccc73;
}
.nav-tabs {
  border-bottom: 0;
  margin-bottom: 0;
  background-color: #f5f5f5;
}
.nav-tabs li {
  width:auto;
}
.nav-tabs li a {
  color:black;
}
.nav-tabs li.active a {
  background-color: #5bad2b;
  color: white;
}
.nav-tabs li.active a:hover {
  background-color: #5bad2b;
  color: white;
}
hr {
    border-top: 1px solid #55555538 !important;
}
hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
.info-box {
  background-color: #f5f5f5 !important;
}
.bg-yellow {
  border-right: 5px solid white;
  background-color: #f5f5f5 !important;
}
.info-box-content {
    padding: 39px 10px;
    margin-left: 90px;
}
.info-box-number {
  font-size: 12px;
}
.resumeview {
  margin-top: 6px;
  margin-right: 20px;
  color: #5bad2b;
}

.btns.resumebtn {
  color: #2b2fadc7;
  border-color: #2b2fadc7;
}
.btns.resumebtn:hover {
  color: #2b2fadc7;
  border-color: #2b2fadc7 !important;
}
.f14 {
  font-size: 14px !important;
}
.cg {
  color: #5bad2b;
}
.c {
  text-align: center;
}
tr th {
  text-align: center;
}
.donate-now {
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 5px 0 0;
  width: 112px;
  height: 52px;
  position: relative;
}

.donate-now input[type="radio"]:checked+label,
.Checked+label {
  background: #5bad2b;
  color:#fff;
}

.donate-now label {
  padding: 5px;
  border: 1px solid #CCC;
  cursor: pointer;
  z-index: 90;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.donate-now label:hover {
  background: #DDD;
}
.table>tbody>tr>td {
  padding: 4px;
}
.direct-chat-name.nametext {
  font-size: 14px;
  font-weight: 400;
}
.box-default {
  border: 1px solid #cccccc6e;
}
.box-header.chart {
  background-color: #f5f5f5;
  border: 1px solid #cccccc6e;
}

.button {
  cursor: pointer;
}
td, th {
    padding: 4px !important;
    font-size: 12px;
}
.box-body:hover {
  background-color: #cccccc59;
  border-left: 4px solid #5bad2b;
  border-bottom-left-radius: 0px;
  border-bottom: 0px solid #ccc;
  border-top: 0px solid #ccc;
}
.box-body.active {
  background-color: #cccccc59;
  border-left: 4px solid #5bad2b;
  border-bottom-left-radius: 0px;
  border-bottom: 0px solid #ccc;
  border-top: 0px solid #ccc;
}
.box-body {
  border-bottom: 0px solid #ccc;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.ic {
  color: #5bad2b;
}
.todo-list>li {
    border-radius: 0px;
    padding: 10px;
    background: #ffffff;
    margin-bottom: 2px;
    border-left: 0px solid #ffffff;
    border-bottom: 1px solid #ccc;
    color: #444;
}
.box-body {
    padding: 10px !important;
}
.box {
  border-top: 1px solid #ededed;
}
.box.box-primary {
    border-top-color: #ededed;
}
.given_rating {
  width: 170px;
  height: 32px;
  position: absolute;
  left: 41%;
}
.ratingform {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 39px;
}
.f19 {
  font-size: 14px;
}
.cg {
  color: #5bad2b;
}
.t-head {
  background-color: #F5F5F5;
  padding: 5px;
}
.c-hr {
  margin-top: 3px;
  margin-bottom: 14px;
}
.f12 {
  font-size: 12px;
}
.text-label {
  color: #919191;
}
.invoice {
  position: relative;
  background: #fff;
  border: 1px solid #f4f4f4;
  padding: 0px !important;
  margin: 0px 0px 0px 0px !important;
}
.page-header {
  margin: 0px 0 9px 0;
  font-size: 22px;
}
.content-wrapper {
  margin-left: 0px !important;
}
.cr {
  color: red;
}
.vue-html2pdf {
  margin-top: 0px !important;
}
section.content-wrapper {
  margin-left: 0px !important;
  margin-top: 0px !important;
}
.emailover {
  display: block;
  /* color: #999; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 156px;
}
.sit-score {
  background-color: #f5f5f5;
  color: #333;
  padding: 10px 15px 10px 15px;
  margin-right: 5px;
}

.sit-score-active {
  background-color: #5bad2b !important;
  color: #fff !important;
  padding: 10px 15px 10px 15px;
  margin-right: 5px;
}
</style>
